module.exports = __webpack_public_path__ + "static/media/ReactivateCompany.2c85dc1c.svg";